"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = exports.MobileSection = exports.DesktopSection = exports.NavSection = exports.NavHR = exports.NavUL = exports.Nav = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = require("../../typography/Typography");

var _link = _interopRequireDefault(require("../../link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Nav = (0, _styledComponents["default"])('nav').withConfig({
  displayName: "top-navstyles__Nav",
  componentId: "chbcz4-0"
})(["width:100%;display:", ";flex-direction:row;grid-column:main-start / main-end;justify-content:space-between;@media ", "{display:", ";}"], function (props) {
  return props.desktopOnly ? 'none' : 'flex';
}, function (props) {
  return props.theme.queries.navbarBreakpoint;
}, function (props) {
  return props.desktopOnly ? 'flex' : 'none';
});
exports.Nav = Nav;
var NavUL = (0, _styledComponents["default"])('ul').withConfig({
  displayName: "top-navstyles__NavUL",
  componentId: "chbcz4-1"
})(["display:flex;flex-direction:column;padding:0 ", "rem ", "rem;@media ", "{padding:0 0 0 56px;flex-direction:row;align-items:center;}li:first-child{padding-top:", "rem;@media ", "{padding-top:0;}}li:not(:first-child){padding-top:12px;@media ", "{padding-top:0;padding-left:32px;}}"], 24 / 16, 24 / 16, function (props) {
  return props.theme.queries.navbarBreakpoint;
}, 32 / 16, function (props) {
  return props.theme.queries.navbarBreakpoint;
}, function (props) {
  return props.theme.queries.navbarBreakpoint;
});
exports.NavUL = NavUL;
NavUL.propTypes = {
  expandMobileMenu: _propTypes["default"].bool
};
var NavHR = (0, _styledComponents["default"])('hr').withConfig({
  displayName: "top-navstyles__NavHR",
  componentId: "chbcz4-2"
})(["border:1px solid ", ";"], function (props) {
  return props.theme.colors.slate.lightest;
});
exports.NavHR = NavHR;
var NavSection = (0, _styledComponents["default"])('div').withConfig({
  displayName: "top-navstyles__NavSection",
  componentId: "chbcz4-3"
})(["display:flex;flex-direction:row;align-items:center;"]);
exports.NavSection = NavSection;
var DesktopSection = (0, _styledComponents["default"])('div').withConfig({
  displayName: "top-navstyles__DesktopSection",
  componentId: "chbcz4-4"
})(["display:none;@media ", "{display:block;}"], function (props) {
  return props.theme.queries.navbarBreakpoint;
});
exports.DesktopSection = DesktopSection;
var MobileSection = (0, _styledComponents["default"])('div').withConfig({
  displayName: "top-navstyles__MobileSection",
  componentId: "chbcz4-5"
})(["display:block;@media ", "{display:none;}"], function (props) {
  return props.theme.queries.navbarBreakpoint;
});
exports.MobileSection = MobileSection;
var NavLink = (0, _styledComponents["default"])(_link["default"]).withConfig({
  displayName: "top-navstyles__NavLink",
  componentId: "chbcz4-6"
})(["--font-weight:500;color:", ";fill:", ";@media ", "{", " display:block;}&:hover{fill:", ";}"], function (props) {
  return props.active ? props.theme.colors.magic.base : props.theme.colors.black;
}, function (props) {
  return props.active ? props.theme.colors.magic.base : '';
}, function (props) {
  return props.theme.queries.navbarBreakpointDown;
}, (0, _Typography.getTypographyVariant)('subheading'), function (props) {
  return props.theme.colors.magic.base;
});
exports.NavLink = NavLink;